import { store } from "@/store";
import { resetOrgState } from "@/store/modules/orgReducer";
import { resetUserState, setLoginStatus } from "@/store/modules/userReducer";
import { removeStorage } from "@/utils/storage";

const profileLogout = () => {
  removeStorage('curUser');
  removeStorage('curOrgId');
  removeStorage('refreshToken');
  removeStorage('accessToken');
  store.dispatch(resetOrgState());
  store.dispatch(resetUserState());
  store.dispatch(setLoginStatus(false));
}

export const supplierProfileLogout = () => {
  removeStorage('SUPPLIER_ACCESS_TOKEN');
  removeStorage('SUPPLIER_ID');
  removeStorage('SUPPLIER_REFRESH_TOKEN');
}

export default profileLogout;